module.exports = __webpack_public_path__ + "img/ai_lifeboat2.f59d45a6.jpg";